import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import type { TrackEvent } from "@/types/generated";
import { UploadedFilesGallery } from "../UploadedFilesGallery";
import { toast } from "sonner";
import { router } from "@inertiajs/react";

interface UploadedFilesCardProps {
  trackEvent: TrackEvent;
}

export function UploadedFilesCard({ trackEvent }: UploadedFilesCardProps) {
  const hasFiles =
    (trackEvent.images?.length || 0) > 0 ||
    (trackEvent.videos?.length || 0) > 0 ||
    (trackEvent.setup_files?.length || 0) > 0;
  if (!hasFiles) return null;

  async function handleDeleteFile(attachmentId: number) {
    try {
      const response = await fetch(
        `/event/${trackEvent.id}/attachment/${attachmentId}`,
        {
          method: "DELETE",
          headers: {
            "X-CSRF-Token":
              document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
                ?.content || "",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("File deleted", {
          description: "The file has been deleted successfully.",
        });
        router.reload({ preserveUrl: true });
      } else {
        toast.error("Delete failed", {
          description: data.error || "Failed to delete file",
        });
      }
    } catch {
      toast.error("Delete failed", {
        description: "An error occurred while deleting the file",
      });
    }
  }

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="text-base">Uploaded Files</CardTitle>
      </CardHeader>
      <CardContent>
        <UploadedFilesGallery
          images={trackEvent.images || []}
          videos={trackEvent.videos || []}
          setup_files={trackEvent.setup_files || []}
          canEdit={trackEvent.can_edit}
          onDelete={handleDeleteFile}
        />
      </CardContent>
    </Card>
  );
}
